import { createFileRoute } from "@tanstack/react-router";

import { OwnershipNetworkPage } from "@/features/ownership-network/page";

// Sibling of ./graphs: same data, opposite entry point. `graphs` walks outward
// from one company; `map` draws a whole reference date at once.
export const Route = createFileRoute("/_authenticated/intel/network/map")({
  component: OwnershipNetworkPage,
});
